import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export const APP_TOKEN_COOKIE = 'user_token';
export const REFRESH_EARLY_MS = 2 * 60 * 1000;
export const CLERK_OIDC_PROMPT = 'select_account';

export function appTokenExpiresAt() {
  const token = Cookies.get(APP_TOKEN_COOKIE);
  if (!token) return 0;
  try {
    return Number(jwtDecode(token)?.exp) * 1000 || 0;
  } catch {
    return 0;
  }
}

export function appTokenNeedsRefresh(now = Date.now()) {
  return appTokenExpiresAt() <= now + REFRESH_EARLY_MS;
}

export function appTokenCookieOptions(hostname) {
  return ['localhost', '127.0.0.1'].includes(hostname)
    ? {}
    : { secure: true, sameSite: 'strict' };
}

export function saveAppToken(token) {
  Cookies.set(APP_TOKEN_COOKIE, token, appTokenCookieOptions(window.location.hostname));
}

export function clearAppToken() {
  Cookies.remove(APP_TOKEN_COOKIE);
}

export async function signOutFromMarstrix(signOut, navigate) {
  clearAppToken();
  await signOut();
  navigate('/sign-in', { replace: true });
}
